import { FunctionComponent } from "react";
import styled from "styled-components";

import CheckMark from "./checkmark";

const SuccessBallWrapper = styled.div`
  border-radius: 50%;
  height: 40px;
  width: 40px;
  background-color: ${({ theme }) => theme.customTheme.palette.SuccessBallWrapper.bgColor};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px auto;

  path {
    fill: ${({ theme }) => theme.customTheme.palette.SuccessBallWrapper.fill};
  }
`;

const SuccessBall: FunctionComponent = () => (
  <SuccessBallWrapper>
    <CheckMark />
  </SuccessBallWrapper>
);

export default SuccessBall;
